"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionLevel = void 0;
var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel["unathorized"] = "unauthorized";
    PermissionLevel["view"] = "view";
    PermissionLevel["edit"] = "edit";
})(PermissionLevel || (exports.PermissionLevel = PermissionLevel = {}));
//# sourceMappingURL=PermissionLevel.js.map